import type { ExploreWorkspaceSeed } from '../workspaceSeeds'

export const SPORTS_ACADEMY_DEMO_SEED: ExploreWorkspaceSeed = {
  id: 'sports-academy-demo',
  name: 'Olympus Sports Academy',
  slug: 'sports-academy-demo',
  summary: 'Multi-sport training academy featuring Football, Swimming, and Tennis with session bookings, progress levels, and skill certification.',
  tags: ['education', 'training', 'sports', 'football', 'swimming', 'tennis'],
  metrics: [
    { label: 'Athletes', value: '30 enrolled' },
    { label: 'Programmes', value: '5 squads' },
  ],
  currency: 'INR',
  budgetLabel: '₹15,000 / month',
  quotaLabel: '30 / 40 athletes',
  sensitiveDemo: {
    label: 'Fake sports demo data',
    items: [
      'marcus.silva@example.test',
      'All athlete data is synthetic (@example.test)',
    ],
  },
  members: [
    { name: 'Coach Marcus Silva', email: 'marcus.silva@example.test', role: 'ADMIN' },
    { name: 'Coach Sarah Jenkins', email: 'sarah.jenkins@example.test', role: 'EDITOR' },
    { name: 'Coach Rohan Bopanna', email: 'rohan.bopanna@example.test', role: 'EDITOR' },
    { name: 'Coach Elena Rostova', email: 'elena.rostova@example.test', role: 'EDITOR' },
    { name: 'David Beckett', email: 'david.beckett@example.test', role: 'EDITOR' },
  ],
  elements: [],
  checklistItems: [],
  featured: true,
  heroGradient: 'MIDNIGHT',
}
